import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const NotificationItem = ({ notification, onMarkAsRead, onDelete }) => {
    const navigate = useNavigate();

    // Get emoji/icon based on notification type
    const getNotificationIcon = (type) => {
        const icons = {
            'lead_assigned': '🎯',
            'lead_assigned_to_desk': '📋',
            'lead_assigned_to_floor': '🏢',
            'lead_bulk_assigned': '🎯',
            'lead_bulk_assigned_to_desk': '📋',
            'lead_bulk_assigned_to_floor': '🏢',
            'lead_imported': '📥',
            'live_lead_created': '🔴',
            'callback_reminder': '📞',
            'email_received': '📧',
            'email_failed': '⚠️'
        };
        return icons[type] || '🔔';
    };

    // Handle click - mark as read and navigate to lead if applicable
    const handleClick = () => {
        if (!notification.isRead) {
            onMarkAsRead(notification._id);
        }

        if (notification.metadata?.messageId) {
            navigate(`/inbox?message=${notification.metadata.messageId}`);
            return;
        }
        if (notification.leadId) {
            navigate(`/leads/edit/${notification.leadId}`);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete(notification._id);
    };

    return (
        <div
            className={`p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors ${
                !notification.isRead ? 'bg-blue-50' : ''
            }`}
            onClick={handleClick}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="flex items-start gap-2 flex-1">
                    <div className="text-xl flex-shrink-0 mt-0.5">
                        {getNotificationIcon(notification.type)}
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2">
                            <h4 className="font-semibold text-sm text-gray-900 truncate">
                                {notification.title}
                            </h4>
                            {!notification.isRead && (
                                <div className="w-2 h-2 bg-blue-600 rounded-full flex-shrink-0 mt-1" />
                            )}
                        </div>
                        <p className="text-xs text-gray-600 mt-1 line-clamp-2">
                            {notification.message}
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                            {moment(notification.createdAt).fromNow()}
                        </p>
                    </div>
                </div>
                <button
                    onClick={handleDelete}
                    className="text-gray-400 hover:text-red-600 p-1 flex-shrink-0 transition-colors"
                    title="Delete notification"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default NotificationItem;

